var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('Header'),_vm._v(" "),_c('Banners',{attrs:{"banner":_vm.banner}}),_vm._v(" "),_c('Introduce',{attrs:{"Introduce":_vm.company_introduction}}),_vm._v(" "),_c('Introduce',{attrs:{"Introduce":_vm.big_data_team_strength}}),_vm._v(" "),_c('CorporateCulture'),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72e3298e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/About_Us.vue
// module id = null
// module chunks = 